import React from 'react';
import { MicroAppCustomProps, MicroAppContext } from '@wppopen/core';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Root } from './Root';

import '@wppopen/components-library/dist/platform-ui-kit/reset.css';
import '@wppopen/components-library/dist/platform-ui-kit/wpp-theme.css';
import { AppWithOSContext } from './AppWithOSContext';
// import 'app/StandaloneRoot.scss';

const singleSpaPropsMock: MicroAppCustomProps = {
    domElementGetter: () => document.createElement('div'),
    osContext: {
        subscribe: (subscribeFn) => {
            subscribeFn({
                tenant: {},
                permissions: {},
                userDetails: {},
                baseUrl: '/',
            } as MicroAppContext);

            return () => {};
        },
    },
    osApi: {
        getAccessToken: () => '',
        analytics: {
            track: () => {},
        },
        navigation: {
            openMenu: () => {},
            openApp: () => {},
            triggerError: () => {},
        },
    },
};

export const StandaloneRoot = () => (
    <Root {...singleSpaPropsMock}>
        <Routes>
            <Route path="standalone">
                <Route path="news" element={<AppWithOSContext />} />
                <Route index element={<Navigate to="news" />} />
            </Route>
            <Route index element={<Navigate to="standalone" />} />
        </Routes>
    </Root>
);
